/**
 * Single source for order-status display. The real lifecycle is
 * PENDING → COMPLETED (deletion is a hard delete) — prod holds nothing
 * else (audit 2026-07-30). Unknown values fall back to the raw code.
 */
const ORDER_STATUS_LABELS: Record<string, string> = {
  pending: 'En cours',
  completed: 'Terminée',
};

export function getOrderStatusLabel(status: string): string {
  return ORDER_STATUS_LABELS[status.toLowerCase()] ?? status;
}

const ORDER_STATUS_BADGE_CLASSES: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-800 border border-yellow-300',
  completed: 'bg-green-100 text-green-800 border border-green-300',
};

export function getOrderStatusBadgeClass(status: string): string {
  return (
    ORDER_STATUS_BADGE_CLASSES[status.toLowerCase()] ??
    'bg-gray-100 text-gray-800 border border-gray-300'
  );
}
